import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { BodyBox } from './style';
// eslint-disable-next-line no-unused-vars
import { Online, Profile, CallScreen } from '../layout';
import { Offline } from '../layout'
import { globalStateSelector } from 'store/selector';
import { connect } from 'react-redux';
import { BodyBox } from 'modules/theme';
import CallInbound from './CallInbound';
import CallBackNotify from './CallBackNotify';
import DTMF from './DTMF';
import OnlineScreen from './OnlineScreen';
import CallBreak from './CallBreak';
import CallBreakSelect from './CallBreakSelect';
import Notification from './Notification';
import CallBackScreen from './CallBackScreen';
// import RecentCall from './RecentCall';
// import OnlineCall from './OnlineCall';
// import CallTag from './CallTag';
// import CallInfo from './CallInfo';
// import AddCall from './AddCall';
// import AddNewCall from './AddNewCall';
// import FAQ from './FAQ';
// import ChatList from './ChatList';
// import MessageList from './MessageList';
// import EndCallProfile from './EndCallProfile';
// import EndCallAgentProfile from './EndCallAgentProfile';
// import EndCallChangePwd from './EndCallChangePwd';
// import Dashboard from '../../../modules/screens/agentdialpad/Dashboard/components/Dashboard';
// import CallDashboard from './CallDashboard';
// import { CallPreviewLoading } from '../../../modules/theme';

export class Body extends Component {
  constructor( props ) {
    super(props);
    this.onlineTab = this.onlineTab.bind(this);
  }
  onlineTab( state, onCall ) {
    const { socketUrl, selectedTab, cbTab, userState } = this.props;
    let callType = "";
    try {
      callType = userState.extraData.callType;
    } catch (error) {
      
    }
    if( socketUrl ) {
      if( onCall && ( state == "AGENT_CONNECTING" || state == "AGENT_RINING" ) && callType == "inboundCall" ) {
        return (<CallInbound />);
      } else if( onCall || state == "preview" ) {
        return (<CallScreen />);
      } else if( state == "callback" ) {
        if( cbTab == "notify" ){
          return (<CallBackNotify />);
        } else if( cbTab == "dial" ){
          return (<CallScreen />);
        } else if( cbTab == "list" ){
          return (<CallBackScreen />);
        } else {
          return (<Offline />);
        }
      } else if( state == "online" ) {
        return (<OnlineScreen />);
      } else if( state == "inboundOffer" ) {
        return (<CallInbound />);
      } else if( selectedTab == 'offlineLoading' ) {
        return (<Offline />);
      } else if( state == "break" ) {
        return (<CallBreakSelect />);
      } else if( state == "notification" ) {
        return (<Notification />);
      } else {
        return (<Offline />);
      }
    } else {
      return (<Offline />);
    }
  }

  render() {
    const { selectedTab, onCall, userState } = this.props;
    let state = userState.State || '';
    //selectedTab = "online"; //TO-DO:remove line
    //onCall = true; //TO-DO:remove line
    console.log({state,selectedTab,onCall,userState},"11111111111111111111111111111")
    return (
      <BodyBox>
        {/* <AddCall /> */}
        {(selectedTab == 'online' || selectedTab == 'offlineLoading') && this.onlineTab( state, onCall )}
        {selectedTab == 'break' && <CallBreak />}
        {selectedTab == 'profile' && <Profile />}
        {selectedTab == 'DTMF' && <DTMF />}
        {selectedTab == 'notification' && <Notification />}
      </BodyBox>
    );
  }
}
Body.contextTypes = {
  __: PropTypes.func,
  onCall: PropTypes.bool
};

const stateToProps = state => ({
  selectedTab: globalStateSelector.getSelectedTab(state),
  userState: globalStateSelector.getState(state),
  socketUrl: globalStateSelector.getDynamic(state, { key: 'socketUrl' }),
  cbTab: globalStateSelector.getDynamic(state, { key: 'cbTab' }),
  onCall: globalStateSelector.getOnCall(state)
});

const dispatchToProps = dispatch => ({
  receiveSocketMessage: data => {
    // console.log(`receiveSocketMessage --> `, data);
    // dispatch(messageAction.receiveSocketMessage(data));
  }
});
export default connect(stateToProps, dispatchToProps)(Body);



// WEBPACK FOOTER //
// src/dialpad/components/layout/Body.js